
/**
 * July 2022
 * @file User Interface constants.
 * @author Jorge Flores Miguel <jorgekain00@gmail.com>
 * @version 1.1.1.001
 */

/**
 * Icon type for alert messages.
 * @typedef {Object} ICONS
 * @property {string} INFO Informative icon.
 * @property {string} WARNING Exclamation mark.
 * @property {string} DANGER x Symbol.
 * @property {string} SUCCESS Check mark.
 * @property {string} CONFIRM Question mark.
 */

/**
 * Constant values for UI use.
 * @typedef {Object} UI_CONSTANTS
 * @property {ICONS} ICONS Icon type for alert messages.
 */

/**
 * Several constant values for general porpuse
 * @type {UI_CONSTANTS}
 * @constant
 */
const JFMUI_CONST = {
    ICONS: {
        INFO: 'INFO',
        WARNING: 'WARNING',
        DANGER: 'DANGER',
        SUCCESS: 'SUCCESS',
        CONFIRM: 'CONFIRM'
    }
};


